import qs from "qs";
import axios from "axios";
import { URL } from "../../../constants/Constants";

/**
 * Obtiene datos completos de una pieza por código
 * @param {string} codeScan - Código de la pieza a buscar
 * @param {number} type - Tipo de consulta (1, 2, etc.)
 * @returns {Promise<Object|false>} Datos de la pieza o false si no se encuentra
 */
export const fullDataPiece = async (codeScan, type) => {
  const queryData = {
    code: codeScan,
    query_type: type,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene datos completos sin validación
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const getFullDataNoValidate = async (currentScreenId, typeConnect) => {
  const queryData = {
    query_type: currentScreenId,
    action: typeConnect,
  };
  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene datos completos de prueba
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const fullDataTest = async (currentScreenId, typeConnect) => {
  const queryData = {
    query_type: currentScreenId,
    query_param: typeConnect,
  };
  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene datos relevantes completos
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const fullDataRelevant = async (currentScreenId, typeConnect) => {
  const queryData = {
    query_type: currentScreenId,
    action: typeConnect,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene todos los datos relevantes
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} query_param - Parámetro de consulta
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const fullDataRelevantAll = async (currentScreenId, query_param) => {
  const queryData = {
    query_type: currentScreenId,
    query_param: query_param,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
